import { IconButton } from '@hsp/react-component-library';

import { Table, ToolbarItems } from '@c/table';

import AddClientGroupSlideOut from '@p/security/users/client-group/components/slide-out/slideout.component';
import { useClientGroupConfiguration } from '@p/security/users/client-group/hooks/configuration-hook';

import { s } from '@u/strings';

const ClientGroupTable = () => {
  const { columns, setIsOpenClientGroup } = useClientGroupConfiguration();

  return (
    <>
      <Table
        columns={columns}
        dataSource={[]}
        enableGlobalFilter
        enablePaging
        globalFilterPlaceHolder={s('Site.Search')}>
        <ToolbarItems>
          <IconButton
            color="outline-primary"
            icon={'add'}
            onClick={() => {
              setIsOpenClientGroup(true);
            }}>
            {s(['Site.New', 'Site.Client', 'Site.Group'])}
          </IconButton>
        </ToolbarItems>
      </Table>
      <AddClientGroupSlideOut />
    </>
  );
};

export default ClientGroupTable;
